import { render, staticRenderFns } from "./dealer-h5-mt45.vue?vue&type=template&id=4b2b3152"
import script from "./dealer-h5-mt45.vue?vue&type=script&lang=js"
export * from "./dealer-h5-mt45.vue?vue&type=script&lang=js"
import style0 from "./dealer-h5-mt45.vue?vue&type=style&index=0&id=4b2b3152&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports